var fails = require('../internals/fails');

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/native-symbol.js
// module id = 577
// module chunks = 0